import { render } from "./Dashboard.vue?vue&type=template&id=5af88a46&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=5af88a46&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af88a46"]])

export default __exports__